/**
 * Les textes de src/content sont affichés avec v-html : leurs liens internes sont de simples <a href="/chemin">.
 * Ce gestionnaire de clic les fait passer par le routeur (pas de rechargement de la page). Dans le HTML prérendu ce sont des liens ordinaires.
 */
export function followInternalLink(event, router) {
    const link = event.target.closest && event.target.closest('a');
    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    if (link.target && link.target !== '_self') return;
    const href = link.getAttribute('href');
    if (href && href.startsWith('/') && !href.startsWith('//')) {
        event.preventDefault();
        router.push(href);
    }
}
